import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Box } from '@sorare/core/src/atoms/ui/Box';
import { ANY_SPORT_SERIES_MARKET_COMMON_PACKS } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';

import packs from './assets/packs.webp';

const Root = styled(Link)`
  aspect-ratio: var(--card-aspect-ratio);
`;
const Wrapper = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--double-unit);
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
  &.empty {
    width: 300px;
    max-width: 100%;
    height: auto;
    aspect-ratio: var(--card-aspect-ratio);
    justify-self: center;
  }
`;
const StyledImg = styled.img`
  width: 100%;
  object-fit: contain;
`;

type Props = {
  empty: boolean;
};
export const DropChallengeEmptyState = ({ empty }: Props) => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Root to={generateSportContextPath(ANY_SPORT_SERIES_MARKET_COMMON_PACKS)}>
      <Wrapper className={classNames({ empty })}>
        {!!empty && (
          <Horizontal center>
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              color="var(--c-yellow-400)"
            />
            <LabelM>
              <FormattedMessage defaultMessage="You don't own any cards that can be used for this challenge" />
            </LabelM>
          </Horizontal>
        )}
        <StyledImg src={packs} alt="" />
        <Button asSpan size="small" color="tertiary">
          <FormattedMessage {...glossary.buyNow} />
        </Button>
      </Wrapper>
    </Root>
  );
};
